<template>
  <div class="captureTrace">
    <div class="capture">
      <span class="dot"></span>
      <span class="subhead">{{ $t('diagnostics.CaptureTrace') }}</span>
      <p>{{ $t('diagnostics.CaptureTraceTip') }}</p>
      <!-- processing -->
      <div style="height: 50px" v-show="isprocessing">
        <el-button type="primary">{{ $t('diagnostics.processing') }}</el-button>
      </div>
      <!-- 开始 -->
      <div style="height: 50px" v-show="showStart">
        <el-button type="primary" @click="start" :disabled="!editable">{{ $t('diagnostics.start') }}</el-button>
      </div>
      <!-- 结束 -->
      <div style=" position: relative;height: 50px" v-show="showEnd">
        <div style="position: absolute;top:0;left:0px">
          <el-button type="primary" @click="end">{{ $t('diagnostics.end') }}</el-button>
        </div>
        <div class="Capturing" style="position: absolute;top:0;left:80px">
          <el-progress
            :text-inside="true"
            :show-text="false"
            :stroke-width="41"
            :percentage="70"
            stroke-linecap="square"
          ></el-progress>
          <span class="T"><i class="el-icon-loading"></i> {{ $t('diagnostics.Capturing') }}</span>
        </div>
      </div>
    </div>
    <div class="DeviceTraceFiles">
      <span class="dot"></span>
      <span class="subhead">{{ $t('diagnostics.DeviceTraceFiles') }}</span>
      <div style="margin-top: 10px; margin-bottom: 10px">
        <el-button type="primary" @click="deleteLogs" :disabled="selected==null||selected.length==0||!editable">
          {{ $t('diagnostics.delete') }}
        </el-button>
      </div>
      <table-pagination
        memory="captureTrace"
        ref="refTable"
        :tableData="tableData"
        :columnData="columnData"
        selectionShow
        @selection-change="selectionChange"
        optionShow
        columnOptionShow
        :total="tabelTotal"
        :currentPage.sync="tabelSearch.currentPage"
        :pageSize.sync="tabelSearch.pageSize"
        @changeCurrentPage="getTabelData"
        @sort-change="tabelSortChange"
        :height="pageTabelHeight/2+15"
      >
        <!-- option -->
        <template slot="option" slot-scope="scope">
          <el-tooltip
            effect="dark"
            :content="$t('diagnostics.download')"
            placement="top"
            :open-delay="1000"
          >
            <el-button type="text" class="btn-p0" @click="download(scope.row.token)">
              <i class="el-icon-download"></i>
            </el-button>
          </el-tooltip>
        </template>
      </table-pagination>
    </div>
  </div>
</template>

<script>
import { TablePagination } from '@/components'
import { diagnostics } from '@/plugins/enums'
import axios from '@/plugins/axios'
import { downloadFile } from '@/plugins/methods'
import {mapGetters} from 'vuex'

export default {
  name: 'captureTrace',
  components: {
    TablePagination,
  },
  props: {
    useOldData: Boolean,
    editable: Boolean,
    recData: String,
    token: String,
  },
  data() {
    return {
      isprocessing: false,
      showStart: true,
      showEnd: false,
      headData: null,
      tableData: [],
      //TODO prop字段未对应
      columnData: [
        {
          label: this.$t('diagnostics.creationTime'),
          prop: 'createTime',
          minWidth: 180,
          filter: 'dateFormat'
        },
        {
          label: this.$t('diagnostics.fileName'),
          prop: 'fileName',
          minWidth: 200,
        },
        {
          label: this.$t('diagnostics.fileSize'),
          prop: 'fileSize',
          minWidth: 180,
        },
      ],
      tabelTotal: 0,
      tabelSearch: {
        currentPage: 1,
        pageSize: 10,
        //TODO确认sortField字段
        sortField: 'creationTime',
        sortOrder: 'asc',
        keywords: null,
      },
      smallToken: null,
      selected:[]
    }
  },
  computed:{
    ...mapGetters('session', ['pageTabelHeight']),
  },
  methods: {
    //开始
    start() {
      let params = {
        typeCode: ['1'],
        token: this.token,
      }
      axios.post('/diagnostics/start', params).then((data) => {
        this.refreshData()
        let subData = data.data.result.rows[0].recDTOMap.package_[0]
        this.smallToken = subData.token
      })
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    //结束
    async end() {
      let params = {
        tokens: [this.smallToken],
      }
      axios.post('/diagnostics/finish', params).then(() => {

      })
      await this.sleep(5000)
      this.refreshData()
    },
    //删除设备日志
    deleteLogs() {
      let selected = this.selected
      if (selected && selected.length > 0) {
        let tokens=[]
        for (let i = 0; i < selected.length; i++) {
          tokens.push(selected[i].token)
        }
        axios.post('/diagnostics/delete',{
          'tokens':tokens
        })
          .then(()=>{
            this.refreshData()
          })
      }
    },
    //下载文件
    download(token) {
      axios.get('/diagnostics/file/' + token,{ responseType: 'blob' }).then((res) => {
        downloadFile(res)
      })
    },
    selectionChange(val) {
      this.selected=val
    },
    tabelSortChange() {},
    getTabelData() {
      this.refreshData()
    },
    refreshData() {
      // 刷新历史列表
      this.tableData = null
      let params = {
        token: this.$route.query.token,
        typeCode: [diagnostics().type.package.code],
        status: [3, 5, 7],
        pageInfo:{
          pageSize: this.tabelSearch.pageSize,
          pageCurrent: this.tabelSearch.currentPage
        }
      }
      if (params.token) {
        axios.post('/diagnostics/readRec', params).then((data) => {
          if (data.data.result.rows[0]) {
            this.tableData = data.data.result.rows[0].recDTOMap.package_
            this.tabelTotal = data.data.result.totalRows
          }
        })
      }

      // 刷新正在执行的
      params = {
        token: this.$route.query.token,
        typeCode: [diagnostics().type.package.code],
        status: [diagnostics().status.process.code],
      }
      if (params.token) {
        axios.post('/diagnostics/readRec', params).then((data) => {
          if (data.data.result.rows[0].recDTOMap.package_) {
            this.headData = data.data.result.rows[0].recDTOMap.package_[0]
            if (this.headData) {
              this.smallToken = this.headData.token
              if (this.headData.status == diagnostics().status.finish.code) {
                this.showEnd = false
                this.showStart = true
              } else if (this.headData.status == diagnostics().status.process.code) {
                this.showEnd = true
                this.showStart = false
              } else if (this.headData.status == diagnostics().status.error.code) {
                this.showEnd = false
                this.showStart = false
              }
            }
          }else{
            this.showEnd = false
            this.showStart = true
          }
        })
      }
    },
  },
  mounted() {
    this.useOldData = this.$route.query.useOldData === 'true'
    this.editable = this.$route.query.editable === 'true'
    this.token = this.$route.query.token
    this.refreshData()
  },
}
</script>

<style lang="scss" scoped>
.dot {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: blue;
  border-radius: 50%;
  margin-right: 5px;
  vertical-align: middle;
}

.subhead {
  font-size: 14px;
  vertical-align: middle;
}

::v-deep .el-progress-bar__outer {
  border-radius: 4px;
}

::v-deep .el-progress-bar__inner {
  border-radius: 0;
}

.Capturing {
  position: relative;
  display: inline-block;
  width: 150px;
  margin-left: 10px;

  .T {
    color: white;
    font-size: 14px;
    width: 180px;
    position: absolute;
    z-index: 10000;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
  }
}
</style>
